<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onNewNotice="newNotice"
        ></header-buttons>
        <b-row>
            <b-col cols="12">
                <admin-notices-table
                        :key="tablekey">
                </admin-notices-table>
            </b-col>
        </b-row>
        <inter-modal
                title-icon="flaticon-mail"
                :buttonPrimary="buttonPrimary"
                :title="titleModal"
                :visible="showModal"
                @onPrimaryClick="saveNotice">
            <admin-notices-form
                    ref="adminNoticesForm"
                    :notice="notice">
            </admin-notices-form>
        </inter-modal>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import InterModal from "../../../components/modal/InterModal";
    import Notice from "@/models/Notice";
    import {mapActions} from 'vuex';
    import AdminNoticesTable from "../components/AdminNoticesTable";
    import AdminNoticesForm from "../forms/AdminNoticesForm";

    export default {
        name: "AdminNoticesListView",
        components: {
            AdminNoticesForm,
            AdminNoticesTable, InterModal, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuova Notice',
                        onClick: 'onNewNotice',
                    }
                ],
                tablekey: 1,
                showModal: false,
                titleModal: 'Nuova Notice',
                buttonPrimary: {
                    label: 'Salva',
                    confirm: true
                },
                notice: Object.assign({}, Notice),
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        methods: {

            ...mapActions({
                adminNoticesStore : 'adminNoticesStore'
            }),

            newNotice: function () {
                this.notice = Object.assign({}, Notice);
                this.showModal = true;
            },

            saveNotice: function () {
                let data = this.notice;
                data.recipies = this.$refs.adminNoticesForm.societies;
                this.adminNoticesStore(data)
                    .then(() => {
                        this.$bvToast.toast('Notifica salvata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.showModal = false;
                        this.tablekey += 1;
                    }).catch(() => {
                    this.$bvToast.toast('Notifica non salvata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            },

        }
    }
</script>

<style scoped>

</style>
